import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
export default {
	all:{
		jiantizhongwen:'简体中文',
		fantizhongwen:'繁体中文',
		yingwen:'英文',
		ribenyu:'日文',
		hanguoyu:'韩文',
		jizhuzhanghao:'记住账号',
		jizhumima:'记住密码',
		yuyanxuanze:'语言选择',
		shezhi:'设置',
		xiugaimima:'修改密码',
		yinsizhengce:'隐私政策',
		guanyuwomen:'关于我们',
		mimashuoming:'密码必须是8-20位大小写字母和数字组合，不能是纯数字或纯字母',
		qingshurujiumima:'请输入旧密码',
		qingshuruxinmima:'请输入新密码',
		quedingxiugai:'确定修改',
		
		shouye:'首页',
		zhibo:'直播',
		wode:'我的',
		xitongxiaoxi:'系统消息',
		wodedingdan:'我的订单',
		bangzhufankui:'帮助反馈',
		xiugaiziliao:'修改资料',
		xiaofeimingxi:'消费明细',
		zhibojilu:'直播记录',
		tijiao:'提交',
		caozuochenggong:'操作成功',
		tishi:'提示',
		quedingtuichudenglu:'确定退出登录吗？',
		queding:'确定',
		wentibangzhu:'问题帮助',
		woyaofankui:'我要反馈',
		fankuiwenti:'反馈问题',
		qingmiaoshuniyaofankuidewenti:'请描叙你要反馈的问题...',
		sousuo:'搜索',
		sousuoniganxingqudeneirong:'搜索你感兴趣的内容',
		zhibojianbiaoti:'直播间标题',
		zhibojianbeijing:'直播间背景',
		xuanzebackground:'选择背景',
		shangchuanbeijing:'上传背景',
		yixuanze:'已选择',
		qingxuanzebeijing:'请选择背景',
		xietongzhiboweiqidong:'协同直播功能未启动',
		zhibojianbiaoqian:'直播间标签',
		zhibojianhuazhi:'直播间画质',
		geinidezhibojianqugemingziba:'给你的直播间取一个名字吧~',
		qingshurukaibomiyao:'请输入开播秘钥',
		kaishizhibo:'开始直播',
		shengyin:'声音',
		liwutexiao:'礼物特效',
		gengduo:'更多',
		gouwuche:'购物车',
		zaixianguanzhong:'在线观众',
		danmushuoming:'平台严禁未成年人充值打赏，严禁以陪玩等方式诱导打赏私下交易，严禁涉黄涉政、谩骂等内容，请注意财产安全，谨防网络诈骗，理性消费。',
		tianjiaguanliyuan:'添加管理员',
		jinyan:'禁言',
		jiechuejinyan:'解除禁言',
		tichufangjian:'踢出房间',
		shangpinxiangqing:'商品详情',
		lijijiagou:'立即加购',
		xuanzeguige:'选择规格',
		quanbuliwu:'全部礼物',
		ge:'个',
		bi:'币',
		guanliyuan:'管理员',
		kuaijieduanyu:'快捷短语',
		gonggao:'公告',
		xinzengkuaijieduanyu:'新增快捷短语',
		qingshuru:'请输入',
		qingshuruzhengque:'请输入正确的金额',
		shuru:'输入',
		wangjimima:'忘记密码',
		youxiangzhuce:'邮箱注册',
		huoquyanzhengma:'获取验证码',
		qingshuruningdeyouxiangzhanghao:'输入您的邮箱账号',
		qingshuruyanzhengma:'请输入验证码',
		qingshurumima:'请输入密码',
		mimadenglu:'密码登录',
		woyiyuedubingtongyi:'我已阅读并同意',
		yonghuxieyi:'用户协议',
		yinsixieyi:'隐私协议',
		denglu:'登录',
		chongxindenglu:'重新登陆',
		xiayibu:'下一步',
		haimeizhanghao:'还没有账号',
		quzhuce:'去注册',
		yiyouzhanghao:'已有账号',
		qudenglu:'去登录',
		shezhijibenxinxi:'设置基本信息',
		nichengtishi:'仅支持字母、数字和标点符号，最少6位，不能使用空格',
		shezhiyonghuming:'设置用户名',
		yonghumingtishi:'用户名为6-18位，大小写字母或数字',
		shezhijiaoyimima:'设置交易密码',
		jiaoyimimatishi:'交易密码必须是6位数字组合',
		qingxuanze:'请选择',
		yaoqingma:'邀请码（选填）',
		qingshuruyaoqingma:'输入邀请码',
		shezhixinmima:'设置新密码',
		xuanzeningdeguojia:'选择您的国家',
		zhuce:'注册',
		qingshuruyonghuming:'请输入用户名',
		gaoqinghuazhi:'高清画质',
		biaoqinghuazhi:'标清画质',
		chaoqinghuazhi:'超清画质',
		putonghuazhi:'普通画质',
		kaishizhibo:'开始直播',
		zengsong:'赠送',
		jinrulezhibojian:'进入直播间',
		shuodianshenmene:'说点什么呢...',
		zanwushuju:'暂无数据',
		songgei:'送给',
		huifang:'回放',
		quedingtuichudengluma:'确定退出登录吗?',
		xunibi:'虚拟币',
		quanbu:'全部',
		appxiazai:'APP下载',
		dingdanjine:'订单金额',
		dingdanbianhao:'订单编号',
		chuangjianshijian:'创建时间',
		zhubozanshilikai:'主播暂时离开',
		mashanghuilai:'马上回来',
		guojianzhuoxiazai:'国际安卓下载',
		anzhuoxiazai:'安卓下载',
		guojipingguoxiazai:'国际苹果下载',
		pingguoxiazai:'苹果下载',
		quanbushangpin:'全部商品',
		yiqiangguang:'已抢光',
		jiagou:'加购',
		shangpinxiangqing:'商品详情',
		lijijiagou:'立即加购',
		yixuan:'已选',
		xuanzeguiige:'选择规格',
		xuazeguige:'选择规格',
		shangchuanzhong:'上传中',
		shangchuanshibai:'上传失败',
		browserbu支持:'您的浏览器不支持媒体设备访问',
		qingkaiqi:'请开启摄像头和麦克风权限',
		meiyoushebei:'未检测到摄像头或麦克风设备',
		shebeibeizhan:'设备被其他程序占用，请关闭后重试',
		quxianchengong:'获取媒体权限失败',
		shifouquedingjieshuzhibo:'是否确定关闭直播？',
		qingyuedubingtongyiyonghuxieyiheyinsixieyi:'请阅读并同意用户协议和隐私协议！',
		quedingqudengluma:'确定去登录吗？',
		duanyingyin:'短影音',
		fabuduanyingyin:'发布短影音',
		zhibohuaxu:'直播花絮',
		qingshurubiaoti:'请输入标题',
		shangchuanduanyingyin:'上传短影音',
		zhibozhongxin:'直播中心',
		zongzichanguzhi:'总资产估值',
		liushuijilu:'流水记录',
		chongbi:'充币',
		tibi:'提币',
		dashang:'打赏',
		riqi:'日期',
		leixing:'类型',
		miaoshu:'描述',
		jine:'金额',
		zhuangtai:'状态',
		yiwancheng:'已完成',
		shenhezhong:'审核中',
		shenhejujue:'审核拒绝',
		kaishiriqi:'开始日期',
		jieshuriqi:'结束日期',
		wangluo:'网络',
		dizhi:'地址',
		tibishuliang:'提币数量',
		daozhangshisuan:'到账试算',
		shouxufei:'手续费',
		meiridaozhang:'每日到账',
		keyong:'可用',
		dongjie:'冻结',
		zuixiaotibishuliang:'最小提币数量',
		shouxufeibilv:'手续费',
		meirishenyueddu:'每日剩余额度',
		shenqingzhibo:'申请直播',
		shenqingjilu:'申请记录',
		huifangjilu:'回放记录',
		yikaifang:'已开放',
		guankanhuifang:'观看回放',
		beisu:'倍数',
		zhiboriqi:'直播日期',
		shijianshiduan:'时间时段',
		shoujizhibo:'手机直播',
		zhibodaihuo:'直播带货',
		kaiqi:'开启',
		guanbi:'关闭',
		beizhu:'备注',
		huodongzhuti:'活动主题、设备说明',
		shenqinghouliucheng:'申请后流程',
		shenqinghouliuchengdesc:'后台审核通过后，将邮件发送直播会铃定直播地址。',
		daishenhe:'待审核',
		tijiaoshenqing:'提交申请',
		qingxuanzeriqi:'请选择直播日期',
		qingxuanzeshijian:'请选择时间时段',
		tijiaochenggong:'提交成功',
		nian:'年',
		yue:'月',
		tongshiduanbukezhongfu:'同时段不可重复',
		keshenqingshiduan:'可申请时段',
		querenShiduan:'确认时段',
		zhanghaoid:'账号 ID',
		qingtianxie:'请填写',
		zhou1:'一',
		zhou2:'二',
		zhou3:'三',
		zhou4:'四',
		zhou5:'五',
		zhou6:'六',
		zhou7:'日',
		shenqingyitijiao:'申请已提交',
		shenqingtijiaodesc:'直播管理员将审核直播间、时段和带货资料。',
		chakanshenheJilu:'查看审核记录',
		shenqingriqi:'申请日期',
		zhiboshijianduan:'直播时间段',
		zhiboleixing:'直播类型',
		daihuo:'带货',
		yitongguo:'已通过',
		weitongguo:'未通过',
		xiangqing:'详情',
		yuanyin:'原因',
		shenqingxiangqing:'申请详情',
		shenheyuanyin:'审核原因',
		xutiaozheng:'需调整',
		shenheyuanyindesc:'该时段直播间已被占用，请重新选择直播日期或时间段后再次提交。',
		wancheng:'完成',
		chulizhong:'处理中',
		daichuli:'待处理',
		houtaishenhe:'后台审核',
		chanshengmiyao:'产生金钥',
		youjiankuaidi:'邮件通知',
		kechakan:'可查看',
		jinwanxinpinfuli:'今晚新品福利直播',
		chehuishenqing:'撤回申请',
		chongxinshenqing:'重新申请',
		zhibojinyao:'直播金钥',
		zhibojian:'直播间',
		keyongshiduan:'可用时段',
		youxiao:'有效',
		tuiliudizhi:'推流地址',
		tuiliumamiyao:'推流码/秘钥',
		youjiantongzhidesc:'同直播间同时段不会重复生成金钥。',
		yifasong:'已发送',
		fuzhiquanbu:'复制全部',
		fuzhichenggong:'复制成功',
		youjiantongzhi:'邮件通知',
		zhiboshenhetongguo:'直播审核通过',
		shoujianren:'收件人',
		youjianneirongdesc:'内容包含直播间、可用时段、推拉流地址、密钥和开播前设置入口',
		youjianbianhao:'邮件编号',
		chongxinfasong:'重新发送',
		yinyuedaren:'音乐达人',
		wudaodaren:'舞蹈达人',
		yanzhi:'颜值',
		jichushezhi:'基础设置',
		yishangchuan:'已上传',
		zhiboshangpin:'直播商品',
		laiziyunimall:'来自 UNImall 商城控制',
		jian:'件',
		zhiboliucheng:'直播流程',
		liuchang:'流畅',
		gaoqing:'高清',
		chaoqing:'超清',
		languang:'蓝光',
		tongguo:'通过',
		jinxingzhong:'进行中',
		daikaiqi:'待开启',
		qianzhizuoye:'前置作业',
		qingshangchuan:'请上传',
		shangpinxuhao:'商品序号',
		shangpinshoutu:'商品首图',
		shangpinmingcheng:'商品名称',
		shangchengkucun:'商城库存',
		zhibokucun:'直播库存',
		shangchengjiage:'商城价格',
		zhibojiage:'直播价格',
		caozuo:'操作',
		yichu:'移除',
		zhibojiansetting:'直播间设置',
		kaiqishengyin:'开启声音',
		guanbishengyin:'关闭声音',
		kaiqidanmu:'开启弹幕',
		guanbidanmu:'关闭弹幕',
		kaiqimeiyan:'开启美颜',
		guanbimeiyan:'关闭美颜',
		kaiqimaikefeng:'开启麦克风',
		guanbimaikefeng:'关闭麦克风',
		kaiqimaike:'开麦克风',
		guanbimaike:'关麦克风',
		gonggao:'公告',
		fenxianglianjie:'分享链接',
		xietongzhibo:'协同直播',
		yaoqingjinbo:'邀请助播',
		tongyikongzhi:'统一控制',
		tichuzhubozb:'踢出选中助播',
		zhuborenshushangxian:'助播人数上限',
		ren:'人',
		tongzhibojinyao:'同直播金钥',
		zhuboquanxian:'助播权限',
		yunxufayan:'允许发言',
		yunxukamai:'允许开麦',
		yunxukashipin:'允许开视频',
		yikaiqi:'已开启',
		shengchengyaoqingjinyao:'生成邀请金钥',
		xietongzhiborenshu:'协同直播人数',
		dangqianzhibo:'当前助播',
		kenenghaiyaoqing:'可能还邀请',
		weizhibo:'位助播',
		baocunshangxian:'保存上限',
		fenxiangyaoqing:'分享邀请',
		yaoqinglianjie:'邀请链接',
		fenxiangfangshi:'分享方式',
		fuzhilianjie:'复制链接',
		baocunerweima:'保存二维码',
		fuzhiyaoqinglianjie:'复制邀请链接',
		zhubo:'助播',
		guanli:'管理',
		yijinru:'已进入',
		maikefeng:'麦克风',
		shexiangtou:'摄像头',
		sheweizhuyemian:'设为主画面',
		quxiaozhuyemian:'取消主画面',
		tichuzhibo:'踢出直播间',
		tichuhoubukejinru:'踢出后不可再进入该直播间',
		tongyikongmai:'统一控麦',
		quanjukongzhi:'全局控制',
		quantijingyin:'全体静音',
		yunxuzhubokaimai:'允许助播开麦',
		yunxuzhubokaishipin:'允许助播开视频',
		huifukaimai:'恢复开麦',
		guanbishipin:'关闭视频',
		kaiqishipin:'开视频',
		yunxushipin:'允许视频',
		yingyongshezhi:'应用设置',
		shipin:'视频',
	kaimai:'开麦',
	weikaiqi:'未开启',
	shipinkaiqi:'视频开启',
	shipinguanbi:'视频关闭',
	bimai:'闭麦',
	yunxufayan:'允许发言',
	jinzhifayan:'禁止发言',
	zhuboxiwei:'助播席位',
		guankanzhibo:'观看直播',
		goumai:'购买',
		goumaishangpin:'购买商品',
		yishouqing:'已售罄',
		qianggou:'抢购',
		dashang:'打赏',
		chakangg:'查看公告',
		quxiao:'取消',
		queren:'确认',
		wodequanbao:'我的钱包',
		jiangjie:'讲解',
		jiangjiezhong:'讲解中',
		kucun:'库存',
		qrcodenotexist:'二维码不存在',
		qrcodesaved:'二维码保存成功',
		wodeqianbao:'我的钱包',
		lianshangbaobishibei:'链上包币市币',
		zonge:'总额',
		keyongshuliang:'可用数量',
		dongjieshuliang:'冻结数量',
		chakanliushui:'查看流水',
		chongzhitip:'充币提示：仅支持同链网络，区块链确认到链转账资产无法找回',
		chongzhishuliang:'充值数量',
		yujidaozhang:'预计到账',
		shijidaozhang:'实际到账',
		lijichongzhi:'立即充值',
		chongzhierweima:'充值二维码',
		chongbidizhi:'充币地址',
		fuzhidizhi:'复制地址',
		chongzhichenggong:'充值成功',
		chongbichenggong:'充币成功',
		bizhong:'币种',
		shuliang:'数量',
		shijian:'时间',
		tibidizhi:'提币地址',
		tibishisuan:'提币试算',
		zuiditixianjin:'最低提现金额',
		meiriyushutixian:'每日剩余提现金额',
		keyongyu:'可用余额',
		tijiaotibi:'提交提币',
		xuanzetibidizhi:'选择提币地址',
		sousuodizhi:'搜索地址',
		xuanze:'选择',
		querentbi:'确认提币',
		xuanzedashangbizhong:'选择打赏币种',
		yue:'余额',
		dashangjine:'打赏金额',
		zhanshidashangxinxi:'展示打赏信息',
		zidingyi:'自定义',
		querendashang:'确认打赏',
		zaixianguanzhong:'在线观众',
		yizhibo:'已直播',
		jieshizhibo:'结束直播',
		zhibozhong:'直播中',
		zanwuzaixianguanzhong:'暂无在线观众',
		shangchuanshibai:'视频上传失败，请稍后重试',
		qingshurucontent:'请填写标题并上传视频',
		fabuchenggong:'发布成功',
		fabushibai:'发布失败',
		qingshurushuju:'请输入数据',
		confirmDelete:'确认删除该视频？',
		shanchuchenggong:'删除成功',
		confirmWithdraw:'确认撤回该视频？',
		chehuichenggong:'撤回成功',
		yongjiujinyan:'永久禁言',
		jiaruzhibo:'加入直播',
		jiaruxietongzhibo:'加入协同直播',
		tuichuxietongzhibo:'退出协同直播',
		zhubojinyao:'助播金钥',
		qingshuruzhubojinyao:'请输入助播金钥',
		jiaru:'加入',
		shenqingchenggong:'申请成功',
		youxiaoqi:'有效期',
		tichubenchang:'踢出本场',
		zhanshidashangxiaoxi:'展示打赏消息',
		zanwugonggao:'暂无公告',
		dashang:'打赏',
		songgei:'送给',
		ge:'个',
		bi:'币',
		zanweiyourenjiaruxietongzhibo:'暂未有人加入协同直播',
		zanweikaiqi:'暂未开启协同直播'
		
	},
}
 


// WEBPACK FOOTER //
// ./src/i18n/langs/cn.js